

















































































import { Component, Prop, Mixins, Model, Watch } from 'vue-property-decorator'
import { HasCustomLoading, HandlesErrors } from '@/assets/mixins'

@Component<PrintDetailDialog>({
  name: 'PrintDetailDialog'
})
export default class PrintDetailDialog extends Mixins(
  HasCustomLoading,
  HandlesErrors
) {
  @Model('input', { type: Boolean, default: false })
  readonly value!: boolean

  @Prop({ type: Object, default: null })
  readonly printParameters!: Record<string, string | string[]> | null

  show = false

  @Watch('value', { immediate: true })
  onValueUpdate(value: boolean) {
    if (this.show == value) return
    this.show = value
  }

  @Watch('show')
  omnShowUpdate(value: boolean) {
    if (this.value == value) return
    this.$emit('input', value)
  }
}
